import { all, takeEvery, call, put } from 'redux-saga/effects'

import { SAGA_LOAD_ORGANIZATIONS, SET_ORGANIZATIONS } from './actions';

import LandmarksAPI from '../shared/api/landmarksid';

function* getOrganizations(action){
  const response = yield call(LandmarksAPI.getOrganizations, action.payload.country);
  if (response.error === null){
    const organizations = response.json.body;

    yield put({
      type: SET_ORGANIZATIONS,
      payload: {
        organizations: response.json.body,
      }
    });
  } else {
    console.log(response);
  }
}

export default function* organizationsSagas() {
  yield all([
    takeEvery(SAGA_LOAD_ORGANIZATIONS, getOrganizations),
  ]);
}



// WEBPACK FOOTER //
// ./src/shared/sagas.js